<template>
	<div>
		<resumeEditInfo v-show="resumeEditInfo" @onShowModer="vOnShowModer" ref="resumeEditInfo"></resumeEditInfo>
		<resumeEditWork v-show="resumeEditWork" @onShowModer="vOnShowModer" ref="resumeEditWork"></resumeEditWork>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import resumeEditInfo from './resumeEditInfo'
import resumeEditWork from './resumeEditWork'

export default {
// import引入的组件需要注入到对象中才能使用
	components: {
		resumeEditInfo,
		resumeEditWork
	},
	props: [],
	data() {
		return {
			resumeEditInfo: true,
			resumeEditWork: false
		}
	},
// 监听属性 类似于data概念
	computed: {},
// 监控data中的数据变化
	watch: {},
// 生命周期 - 创建完成（可以访问当前this实例）
	created() {
		console.log('created')
	},
// 生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
		console.log('mounted')
	},
	beforeCreate() {
		console.log('beforeCreate')
	}, // 生命周期 - 创建之前
	beforeMount() {
		console.log('beforeMount')
	}, // 生命周期 - 挂载之前
	beforeUpdate() {
		console.log('beforeUpdate')
	}, // 生命周期 - 更新之前
	updated() {
		console.log('updated')
	}, // 生命周期 - 更新之后
	beforeDestroy() {
		console.log('beforeDestroy')
	}, // 生命周期 - 销毁之前
	destroyed() {
		console.log('destroyed')
	}, // 生命周期 - 销毁完成
	activated() {
		console.log('activated')
	},
// 方法集合
	methods: {
		// 点击保存并下一步显示
		vOnShowModer: function (childValue) {

			console.log('进入父类方法页面')
			switch (childValue) {
				// 点击下一步
				case 'showResumeEditInfo':
					this.onShowResumeEditInfo()
					break
				case 'showResumeEditWork':
					this.onShowResumeEditWork()
					break
				default:
			}
		},
		// 显示基本信息页面
		onShowResumeEditInfo: function () {
			this.resumeEditInfo = true
			this.resumeEditWork = false
			document.body.scrollTop = document.documentElement.scrollTop = 0
			this.$refs.resumeEditInfo.getInfo()
		},
		// 显示工作成就页面
		onShowResumeEditWork: function () {
			this.resumeEditInfo = false
			this.resumeEditWork = true
			document.body.scrollTop = document.documentElement.scrollTop = 0
		},
	}
}
</script>
<style lang='scss' scoped>
	// @import url(); 引入公共css类


</style>
